import React from "react";

import "../styles/bulma_loader.scss";
import "../styles/main.scss";

import Layout from "../components/Layout";
import Oeffnungszeiten from "../components/Oeffnungszeiten";
import Kontakt from "../components/Kontakt";
import Schiessanlage from "../components/Schiessanlage";
import BankverbindungUndAdressErfassung from "../components/BankverbindungUndAdressErfassung";
import Vereinsmeisterschaft2026 from "../components/Vereinsmeisterschaft2026";
import Termine2026 from "../components/Termine2026";

const IndexPage = () => {
  return (
    <Layout>
      <div className="columns features ml-1 mr-1">
        <div className="column is-4">
          <div className="card full-width">
            <div className="card-content">
              <Oeffnungszeiten />
            </div>
          </div>
        </div>
        <div className="column is-4">
          <div className="card full-width">
            <div className="card-content">
              <Schiessanlage />
            </div>
          </div>
        </div>
        <div className="column is-4">
          <div className="card full-width">
            <div className="card-content">
              <Kontakt />
            </div>
          </div>
        </div>
      </div>
      <div className="card full-width block">
        <div className="card-content">
          <div className="content is-size-5">
            <h1 className="title">Wurftauben: Nur Bockdoppelflinte</h1>
            <p>
              Ab dem 25.07.2026 ist auf unserem Schießstand das Schießen auf
              Wurftauben&nbsp;
              <strong className="is-size-5">
                nur mit einer Bockdoppelflinte
              </strong>{" "}
              gestattet.
            </p>
            <p>Mit freundlichen Grüßen</p>
            <p>Der Vorstand</p>
          </div>
        </div>
      </div>
      <div className="card full-width block">
        <div className="card-content">
          <Termine2026 />
        </div>
      </div>
      <div className="card full-width block">
        <div className="card-content">
          <Vereinsmeisterschaft2026 />
        </div>
      </div>
      <div className="card full-width block">
        <div className="card-content">
          <BankverbindungUndAdressErfassung />
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
